import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Layout from '../components/Layout';

const Routes = () => (
  <BrowserRouter>
    <Layout>
      <Switch>
        <Route
          exact
          path="/"
          component={ window.location.assign('https://www.amcor.com/careers/graduate') }
        />
      </Switch>
    </Layout>
  </BrowserRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js